<app-tab-toolbar [accessTabId]="'details'" [selectedYear]="selectedYear" [saveDisabled]="!hasChanges" (yearChange)="onYearChange($event)" (save)="onSave()">
  @if (showYearWarning) {
    <div class="year-warning">
      <mat-icon>warning</mat-icon>
      <span>There is no data for the selected year</span>
    </div>
  }
</app-tab-toolbar>

<div class="columns-wrapper" [formGroup]="form" [appReadOnlyTab]="'details'">

  <!-- ── LEFT COLUMN ──────────────────────────────────────────────────── -->
  <div class="column">

    <section class="section-container nrg-border-radius-second-level">
      <div class="section-header">
        Basic Information
      </div>
      <div class="section-content">
        <div class="form-field-container">
          <mat-form-field appearance="fill" class="form-field" subscriptSizing="dynamic">
            <mat-label>Company Name</mat-label>
            <input matInput formControlName="companyName">
            <mat-error>Company Name is required</mat-error>
          </mat-form-field>
        </div>
        <div class="form-field-container form-field-container-with-columns">
          <div class="form-field-container-half">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Country</mat-label>
              <mat-select formControlName="countryId">
                @for (country of countries; track country.id) {
                  <mat-option [value]="country.id">{{ country.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-field-container-half">
            <mat-form-field appearance="fill" class="form-field" [class.auto-fill-flash]="currencyAutoFilled">
              <mat-label>Currency</mat-label>
              <mat-select formControlName="currencyId">
                @for (currency of currencies; track currency.id) {
                  <mat-option [value]="currency.id">{{ currency.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="form-field-container form-field-container-with-columns">
          <div class="form-field-container-half">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Address</mat-label>
              <input matInput formControlName="address">
            </mat-form-field>
          </div>
          <div class="form-field-container-half">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Board Type</mat-label>
              <mat-select formControlName="boardType">
                @for (option of boardTypeOptions; track option.value) {
                  <mat-option [value]="option.value">{{ option.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="form-field-container">
          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Website</mat-label>
            <input matInput formControlName="website">
          </mat-form-field>
        </div>
        <div class="form-field-container form-field-container-with-columns">
          <div class="form-field-container-half">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Industry</mat-label>
              <mat-select formControlName="industryId">
                @for (industry of industries; track industry.id) {
                  <mat-option [value]="industry.id">{{ industry.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-field-container-half">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Super Sector</mat-label>
              <mat-select formControlName="superSectorId">
                @for (superSector of superSectors; track superSector.id) {
                  <mat-option [value]="superSector.id">{{ superSector.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="form-field-container form-field-container-with-columns">
          <div class="form-field-container-half">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Sector</mat-label>
              <mat-select formControlName="sectorId">
                @for (sector of sectors; track sector.id) {
                  <mat-option [value]="sector.id">{{ sector.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-field-container-half">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Sub Sector</mat-label>
              <mat-select formControlName="subSectorId">
                @for (subSector of subSectors; track subSector.id) {
                  <mat-option [value]="subSector.id">{{ subSector.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </section>

    <section class="section-container nrg-border-radius-second-level">
      <div class="section-header">
        Founders
      </div>
      <div class="section-content">
        <div class="form-field-container">
          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Founder 1</mat-label>
            <input matInput formControlName="founder1">
          </mat-form-field>
        </div>
        <div class="form-field-container">
          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Founder 2</mat-label>
            <input matInput formControlName="founder2">
          </mat-form-field>
        </div>
        <div class="form-field-container">
          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Founder 3</mat-label>
            <input matInput formControlName="founder3">
          </mat-form-field>
        </div>
        <div class="form-field-container">
          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Founder 4</mat-label>
            <input matInput formControlName="founder4">
          </mat-form-field>
        </div>
        <div class="form-field-container">
          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Founder 5</mat-label>
            <input matInput formControlName="founder5">
          </mat-form-field>
        </div>
        <div class="form-field-container founders-name-field">
          <mat-checkbox formControlName="foundersName">Founders Name</mat-checkbox>
        </div>
      </div>
    </section>

    <section class="section-container nrg-border-radius-second-level">
      <div class="section-header">
        Active Measurements
      </div>
      <div class="section-content">
        <div class="section-field">
          <div class="select-with-button">
            <mat-form-field appearance="fill" class="form-field">
              <mat-select [value]="selectedMeasurements" (selectionChange)="onMeasurementsSelectionChange($event)" [disabled]="isReadOnly()" placeholder="Select Measurements" multiple>
                @for (measurement of measurements; track measurement) {
                  <mat-option [value]="measurement">{{ measurement }}</mat-option>
                }
                <mat-select-trigger>
                  @if (selectedMeasurements.length > 0) {
                    {{ selectedMeasurements[0] }}
                    @if (selectedMeasurements.length > 1) {
                      <span class="additional-count">
                        +{{ selectedMeasurements.length - 1 }} more
                      </span>
                    }
                  }
                </mat-select-trigger>
              </mat-select>
            </mat-form-field>
            @if (!isReadOnly()) {
              <button mat-icon-button type="button" (click)="selectAllMeasurements()" matTooltip="Select all measurements">
                <mat-icon>select_all</mat-icon>
              </button>
              <button mat-icon-button type="button" (click)="deselectAllMeasurements()" matTooltip="Deselect all measurements">
                <mat-icon>deselect</mat-icon>
              </button>
            }
          </div>
        </div>
        <div class="section-selections">
          <mat-chip-set aria-label="Selected measurements">
            @for (year of selectedMeasurements; track year) {
              <mat-chip class="chip-basic-item">{{ year }}</mat-chip>
            }
          </mat-chip-set>
        </div>
      </div>
    </section>

  </div>

  <!-- ── RIGHT COLUMN ─────────────────────────────────────────────────── -->
  <div class="column">

    <section class="section-container nrg-border-radius-second-level">
      <div class="section-header">
        Market Information
      </div>
      <div class="section-content">
        <div class="form-field-container form-field-container-with-columns">
          <div class="form-field-container-half">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Stock Symbol</mat-label>
              <input matInput formControlName="stockSymbol">
            </mat-form-field>
          </div>
          <div class="form-field-container-half">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>ISIN</mat-label>
              <input matInput formControlName="isin">
            </mat-form-field>
          </div>
        </div>
        <div class="form-field-container form-field-container-with-columns">
          <div class="form-field-container-half">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Year Went Public</mat-label>
              <input matInput type="text" formControlName="yearWentPublic"
                     maxlength="10"
                     (focus)="onDateFocus($event)" (blur)="onDateBlur($event)"
                     (input)="onYearDateInput($event, 'yearWentPublic')">
            </mat-form-field>
          </div>
          <div class="form-field-container-half">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Year of Founding</mat-label>
              <input matInput type="text" formControlName="yearOfFounding"
                     maxlength="10"
                     (focus)="onDateFocus($event)" (blur)="onDateBlur($event)"
                     (input)="onYearDateInput($event, 'yearOfFounding')">
            </mat-form-field>
          </div>
        </div>
        @if (companyId) {
          <div class="form-field-container">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Capitalization</mat-label>
              <mat-select [value]="capitalization" (selectionChange)="onCapitalizationChange($event.value)" [disabled]="isReadOnly()">
                @for (option of capitalizationOptions; track option.value) {
                  <mat-option [value]="option.value">{{ option.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }
      </div>
    </section>

    @if (companyId) {
      <section class="section-container nrg-border-radius-second-level">
        <div class="section-header">
          Stock Exchanges
        </div>
        <div class="section-content">
          <div class="section-field">
            <div class="select-with-button">
              <mat-form-field appearance="fill" class="form-field">
                <mat-select [value]="selectedStockExchanges" (selectionChange)="onStockExchangesSelectionChange($event)" [disabled]="isReadOnly()" placeholder="Select Stock Exchanges" multiple>
                  @for (exchange of stockExchanges; track exchange.id) {
                    <mat-option [value]="exchange.id">{{ exchange.name }}</mat-option>
                  }
                  <mat-select-trigger>
                    @if (selectedStockExchanges.length > 0) {
                      {{ getStockExchangeName(selectedStockExchanges[0]) }}
                      @if (selectedStockExchanges.length > 1) {
                        <span class="additional-count">
                          +{{ selectedStockExchanges.length - 1 }} more
                        </span>
                      }
                    }
                  </mat-select-trigger>
                </mat-select>
              </mat-form-field>
              @if (!isReadOnly()) {
                <button mat-icon-button type="button" (click)="selectAllStockExchanges()" matTooltip="Select all stock exchanges">
                  <mat-icon>select_all</mat-icon>
                </button>
                <button mat-icon-button type="button" (click)="deselectAllStockExchanges()" matTooltip="Deselect all stock exchanges">
                  <mat-icon>deselect</mat-icon>
                </button>
              }
            </div>
          </div>
          <div class="section-selections">
            <mat-chip-set aria-label="Selected stock exchanges">
              @for (exchangeId of selectedStockExchanges; track exchangeId) {
                <mat-chip class="chip-basic-item">{{ getStockExchangeName(exchangeId) }}</mat-chip>
              }
            </mat-chip-set>
          </div>
        </div>
      </section>

      <section class="section-container nrg-border-radius-second-level">
        <div class="section-header">
          Stock Indexes
        </div>
        <div class="section-content">
          <div class="section-field">
            <div class="select-with-button">
              <mat-form-field appearance="fill" class="form-field">
                <mat-select [value]="selectedStockIndexes" (selectionChange)="onStockIndexesSelectionChange($event)" [disabled]="isReadOnly()" placeholder="Select Stock Indexes" multiple>
                  @for (index of filteredStockIndices; track index.id) {
                    <mat-option [value]="index.id">{{ index.name }}</mat-option>
                  }
                  <mat-select-trigger>
                    @if (selectedStockIndexes.length > 0) {
                      {{ getStockIndexName(selectedStockIndexes[0]) }}
                      @if (selectedStockIndexes.length > 1) {
                        <span class="additional-count">
                          +{{ selectedStockIndexes.length - 1 }} more
                        </span>
                      }
                    }
                  </mat-select-trigger>
                </mat-select>
              </mat-form-field>
              @if (!isReadOnly()) {
                <button mat-icon-button type="button" (click)="selectAllStockIndexes()" matTooltip="Select all stock indexes">
                  <mat-icon>select_all</mat-icon>
                </button>
                <button mat-icon-button type="button" (click)="deselectAllStockIndexes()" matTooltip="Deselect all stock indexes">
                  <mat-icon>deselect</mat-icon>
                </button>
              }
            </div>
          </div>
          <div class="section-selections">
            <mat-chip-set aria-label="Selected stock indexes">
              @for (indexId of selectedStockIndexes; track indexId) {
                <mat-chip class="chip-basic-item">{{ getStockIndexName(indexId) }}</mat-chip>
              }
            </mat-chip-set>
          </div>
        </div>
      </section>

      <section class="section-container nrg-border-radius-second-level">
        <div class="section-header">
          Other Countries
        </div>
        <div class="section-content">
          <div class="section-field">
            <div class="select-with-button">
              <mat-form-field appearance="fill" class="form-field">
                <mat-select [value]="selectedOtherCountries" (selectionChange)="onOtherCountriesSelectionChange($event)" [disabled]="isReadOnly()" placeholder="Select Countries" multiple>
                  @for (country of countries; track country.id) {
                    <mat-option [value]="country.id">{{ country.name }}</mat-option>
                  }
                  <mat-select-trigger>
                    @if (selectedOtherCountries.length > 0) {
                      {{ getCountryName(selectedOtherCountries[0]) }}
                      @if (selectedOtherCountries.length > 1) {
                        <span class="additional-count">
                          +{{ selectedOtherCountries.length - 1 }} more
                        </span>
                      }
                    }
                  </mat-select-trigger>
                </mat-select>
              </mat-form-field>
              @if (!isReadOnly()) {
                <button mat-icon-button type="button" (click)="selectAllOtherCountries()" matTooltip="Select all countries">
                  <mat-icon>select_all</mat-icon>
                </button>
                <button mat-icon-button type="button" (click)="deselectAllOtherCountries()" matTooltip="Deselect all countries">
                  <mat-icon>deselect</mat-icon>
                </button>
              }
            </div>
          </div>
          <div class="section-selections">
            <mat-chip-set aria-label="Selected other countries">
              @for (countryId of selectedOtherCountries; track countryId) {
                <mat-chip class="chip-basic-item">{{ getCountryName(countryId) }}</mat-chip>
              }
            </mat-chip-set>
          </div>
        </div>
      </section>
    }

    <section class="section-container nrg-border-radius-second-level">
      <div class="section-header">
        Former Name & Deregistration
      </div>
      <div class="section-content">
        <div class="form-field-container">
          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Former Name</mat-label>
            <input matInput formControlName="formerName">
          </mat-form-field>
        </div>
        <div class="form-field-container">
          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Former Name Description</mat-label>
            <textarea matInput formControlName="formerNameDescription" rows="2"></textarea>
          </mat-form-field>
        </div>
        <div class="form-field-container">
          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Deleted Date</mat-label>
            <input matInput type="text" formControlName="deletedDate"
                   maxlength="10"
                   (focus)="onDateFocus($event)" (blur)="onDateBlur($event)"
                   (input)="onYearDateInput($event, 'deletedDate')">
          </mat-form-field>
        </div>
        <div class="form-field-container">
          <mat-form-field appearance="fill" class="form-field deregistration-reason-field">
            <mat-label>Deregistration Reason</mat-label>
            <mat-select formControlName="deregistrationReasonId">
              @for (reason of deregistrationReasons; track reason.id) {
                <mat-option [value]="reason.id">{{ reason.name }}</mat-option>
              }
            </mat-select>
            @if (!isReadOnly() && form.get('deregistrationReasonId')?.value) {
              <button matSuffix mat-icon-button type="button" tabindex="-1"
                      aria-label="Clear deregistration reason"
                      (click)="$event.stopPropagation(); clearDeregistrationReason()">
                <mat-icon>close</mat-icon>
              </button>
            }
          </mat-form-field>
        </div>
        <div class="form-field-container">
          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Deregistration Description</mat-label>
            <textarea matInput formControlName="deregistrationDescription" rows="2"></textarea>
          </mat-form-field>
        </div>
      </div>
    </section>

  </div>

</div>
